import { Box, Stack, useTheme } from "@mui/material";
import { useCatalogContext } from "../Summary/context/useCatalogContext";
import { ActionOverviewCard } from "src/components/Actions/Common/ActionOverviewCard";

export const CatalogItemDetail = () => {
    const { currentAction } = useCatalogContext();
    const theme = useTheme();

    if (currentAction === undefined) {
        return null;
    }

    if (currentAction.imageUrl) {
        return (
            <ActionOverviewCard
                description={currentAction.description}
                imageUrl={currentAction.imageUrl}
                variant="catalog"
            />
        );
    }

    if (currentAction.description === undefined) {
        return null;
    }

    return (
        <Stack
            padding={theme.spacing(3)}
            boxShadow={`0px 2px 8px 0px #2A2B270A`}
            border={`1px solid ${theme.custom.grey[600]}`}
            borderRadius={`12px`}
            bgcolor={"white"}
            alignItems={"center"}
        >
            <Box dangerouslySetInnerHTML={{ __html: currentAction.description }} />
        </Stack>
    );
};
